import { Pagination } from '@store/common/pagination.model';
import { TableFilter, TableFilterType } from '@store/common/tableFilter.model';
import { ServiceKind } from '@store/settings/serviceKinds';
import { SuppliersUnit } from '@store/suppliers/units/suppliers-units.model';

export interface SupplierUnitsProposalDto {
  id: number;
  name: string;
}

export interface AuditOfferSupplierUpdateDto {
  id:	number;
  serviceKindId:  number;
  unitCostInCents:  number;
  status: string;
}

export interface UpdateAuditProposalSupplierDto {
  auditOfferSuppliers:  AuditOfferSupplierUpdateDto[];
}

export interface AuditOfferSupplierLightDto {
  id:	number;
  container:  string;
  waste:  string;
  auditProposal:  string;
  unitCostInCents:  number;
  status: string;
  costHistory:  string;
  serviceKind: ServiceKind;
  family: string;
  isInitialOffer: boolean;
}

export interface AuditProposalSuppliersFilters {
  search: string;
  tableFilters: TableFilter[];
}

export namespace AuditProposalSuppliersFilters {
  export const initTableFilters = () => TableFilterType.initTableFilters([
    TableFilterType.ORGANISATION_TYPOLOGY,
    TableFilterType.ORGANISATION_DOMAIN,
  ]);
}

export interface AuditProposalSuppliersPagination extends Pagination {
  data: AuditProposalSuppliers[];
}

export interface AuditProposalSuppliers {
  id: number;
  createdAt: string;
  clientName: string;
  name: string;
  supplierUnit: SuppliersUnit;
  sentAt: string;
  answeredAt: string;
  validatedAt: string;
  consultUrl: string;
  email: string;
}